export const customerCod317Fields = [{
        name: "cod317",
        title: "Codice 317",
        render: (record) => record.cod317
    }];
